import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import axios from '../../../utils/axiosConfig';

import ModalBaseSm from '../../modals/modal-base-sm';
import FormModalCreateRuta from '../forms/formModalaCreateRuta';


const ModalRutas = ({ bitInserts, bitEdits, bitDeletes }) => {
    // estados para ciudades, rutas y form
    const [ciudades, setCiudades] = useState([]);
    const [rutas, setRutas] = useState([]);

    const [origen, setOrigen] = useState('');
    const [destino, setDestino] = useState('');
    const [descripcion, setDescripcion] = useState(null);
    const [idEdit, setIdEdit] = useState(-1);

    const [latOrigen, setLatOrigen] = useState(null);
    const [lngOrigen, setLngOrigen] = useState(null);
    const [latDestino, setLatDestino] = useState(null);
    const [lngDestino, setLngDestino] = useState(null);

    const [searchTerm, setSearchTerm] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);

    // carga inicial
    useEffect(() => {
        listarCiudades();
        listarRutas();
    }, []);

    const listarCiudades = () => {
        axios.get(`${process.env.REACT_APP_SERVER}/maestros/getciudades`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('tkn')}`,
            }, withCredentials: true
        })
            .then(res => res.data.success
                ? setCiudades(res.data.data)
                : Swal.fire('Error', 'No se pudieron cargar ciudades', 'error')
            )
            .catch(() => Swal.fire('Error', 'Falla de red ciudades', 'error'));
    };

    const listarRutas = () => {
        axios.get(`${process.env.REACT_APP_SERVER}/maestros/getrutas`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('tkn')}`,
            }, withCredentials: true
        })
            .then(res => res.data.success
                ? setRutas(res.data.data)
                : Swal.fire('Error', 'No se pudieron cargar rutas', 'error')
            )
            .catch(() => Swal.fire('Error', 'Falla de red rutas', 'error'));
    };

    // callbacks que el hijo llamará
    const handleOrigenChange = async ciudadId => {
        setOrigen(ciudadId);
        const res = await axios.post(
            `${process.env.REACT_APP_SERVER}/maestros/getlocationciudad`,
            { ciudad: ciudadId },
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` }, withCredentials: true }
        );
        const { Latitud, Longitud } = res.data.data[0];
        setLatOrigen(Latitud);
        setLngOrigen(Longitud);
    };

    const handleDestinoChange = async ciudadId => {
        setDestino(ciudadId);
        const res = await axios.post(
            `${process.env.REACT_APP_SERVER}/maestros/getlocationciudad`,
            { ciudad: ciudadId },
            { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` }, withCredentials: true }
        );
        const { Latitud, Longitud } = res.data.data[0];
        setLatDestino(Latitud);
        setLngDestino(Longitud);
    };

    const limpiarCampos = () => {
        setOrigen('');
        setDestino('');
        setDescripcion('');
        setIdEdit(-1);
        setLatOrigen(null);
        setLngOrigen(null);
        setLatDestino(null);
        setLngDestino(null);
    };

    const toggleDialog = () => {
        if (!dialogOpen && idEdit === -1) limpiarCampos();
        setDialogOpen(open => !open);
    };

    const handleChangeSubmitRuta = async (payload) => {
        console.log('Payload recibido:', payload);
        if (payload?.id !== null && payload?.id !== undefined && payload?.id !== -1) {
            console.log('Actualizando ruta:', payload);
            updateRuta(payload);

        } else {
            console.log('Creando nueva ruta:', payload);
            grabarRuta(payload);
        }

    };

    const updateRuta = async (payload) => {
        console.log('Actualizando ruta con payload:', payload);
        const { origen, destino, descripcion, latOrigen, lngOrigen, latDestino, lngDestino, id } = payload;

        if (!origen || !destino) {
            Swal.fire('Error', 'Complete Origen y Destino', 'error');
            return;
        }


        const payloadUpdate = {
            IdRuta: id,
            DescripcionRuta: descripcion !== "" ? descripcion : null,
            latorigen: latOrigen,
            lngorigen: lngOrigen,
            latdestino: latDestino,
            lngdestino: lngDestino,
            FKLokCiudadOrigen: origen,
            FKLokCiudadDestino: destino
        };

        console.log('Payload que envío al servidor:', payloadUpdate);

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SERVER}/maestros/setupdateruta`,
                JSON.stringify(payloadUpdate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`
                    },
                    withCredentials: true
                }
            );
            console.log('Respuesta updateRuta:', res.data);
            if (!res.data.success) throw new Error();
            Swal.fire('Éxito', 'Ruta actualizada exitosamente', 'success');
            listarRutas();
            limpiarCampos();
            toggleDialog();
        } catch (err) {
            console.error('Error en updateRuta:', err);
            Swal.fire('Error', 'No se pudo actualizar ruta', 'error');
        }
    };


    const grabarRuta = async (payload) => {
        console.log('Grabar ruta con payload:', payload);
        const { origen, destino, descripcion, latOrigen, lngOrigen, latDestino, lngDestino } = payload;

        if (!origen || !destino) {
            Swal.fire('Error', 'Complete origen y destino', 'error');
            return;
        }


        const payloadSubmit = {
            DescripcionRuta: descripcion !== "" ? descripcion : null,
            latorigen: latOrigen,
            lngorigen: lngOrigen,
            latdestino: latDestino,
            lngdestino: lngDestino,
            FKLokCiudadOrigen: origen,
            FKLokCiudadDestino: destino
        };
        console.log('Payload que envío al servidor:', payloadSubmit);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SERVER}/maestros/setinsertruta`,
                JSON.stringify(payloadSubmit),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`
                    }, withCredentials: true
                }
            );
            console.log('Respuesta grabarRuta:', res.data);
            if (!res.data.success) throw new Error();
            Swal.fire('Éxito', 'Ruta guardada exitosamente', 'success');
            listarRutas();
            limpiarCampos();
            toggleDialog();
        } catch {
            Swal.fire('Error', 'No se pudo guardar ruta', 'error');
        }
    };

    // filtrado simple
    const filteredRutas = rutas.filter(r =>
        r.DescripcionRuta.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const editarRuta = item => {
        console.log('ruta a editar:', item);
        setIdEdit(item.IdRuta);
        setDescripcion(item.DescripcionRuta);
        handleOrigenChange(item.FKLokCiudadOrigen);
        handleDestinoChange(item.FKLokCiudadDestino);
        setLatOrigen(item.latorigen);
        setLngOrigen(item.lngorigen);
        setLatDestino(item.latdestino);
        setLngDestino(item.lngdestino);
        setDialogOpen(true);
    };

    const borrarRuta = id => {
        Swal.fire({
            title: '¿Está seguro?',
            text: 'No reversible',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar'
        }).then(result => {
            if (result.isConfirmed) {
                axios.delete(`${process.env.REACT_APP_SERVER}/maestros/deleteruta/${id}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('tkn')}` },
                    withCredentials: true
                })
                    .then(() => listarRutas());
            }
        });
    };

    return (
        <>
            <Row className="mb-4 align-items-center">
                <Col sm="6">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar ruta..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>
                <Col sm="6" className="d-flex justify-content-end">
                    <button
                        className="Button blue"
                        onClick={() => { setIdEdit(-1); if (bitInserts) toggleDialog(); }}
                        style={{ height: '38px', minWidth: '150px' }}
                    >
                        Nueva Ruta
                    </button>
                </Col>
            </Row>

            {/* TABLA DE RUTAS */}
            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive text-nowrap"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table className="table table-hover" style={{ width: '100%' }}>
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th style={{ color: '#fff', width: '50%' }}>Descripción</th>
                                <th style={{ color: '#fff', width: '30%', textAlign: 'center' }}>
                                    Km
                                </th>
                                <th style={{ color: '#fff', width: '20%', textAlign: 'center' }}>
                                    Acciones
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRutas.map((r, i) => (
                                <tr key={i}>
                                    <td style={{ color: '#000' }}>
                                        {r.DescripcionRuta || '-'}
                                    </td>
                                    <td style={{ color: '#000', textAlign: 'center' }}>
                                        {r.kmsRuta ?? 0}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                if (bitEdits) editarRuta(r);
                                            }}
                                        >
                                            <i
                                                className="bx bxs-pencil bx-tada"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>{' '}
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                // borrarRuta(r.IdRuta);
                                            }}
                                        >
                                            <i
                                                className="bx bx-trash"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <ModalBaseSm
                isOpen={dialogOpen}
                title={idEdit === -1 ? 'Crear ruta' : 'Editar ruta'}
                onClose={toggleDialog}
                childComponent={
                    <FormModalCreateRuta
                        initialData={{ origen, destino, descripcion, ciudades }}
                        onSave={handleChangeSubmitRuta}
                        onCancel={toggleDialog}
                        ciudades={ciudades}
                        idToEdit={idEdit}
                    />
                }
            />
        </>
    );
};

export default ModalRutas;
